import { ImageName } from "@mcleod/images";
import { DataSourceMode, Image, Label, Layout, Panel, SlideoutDecorator, TableRowDisplayEvent, TableRowExpansionEvent } from "@mcleod/components";
import { AutogenLayoutQualificationDetailSlideout } from "./autogen/AutogenLayoutQualificationDetailSlideout";
import { Api, HorizontalAlignment, ModelRow } from "@mcleod/core";

export class QualificationDetailSlideout extends AutogenLayoutQualificationDetailSlideout {
    static showSlideout(payeeId: string) {
        const layout = Layout.getLayout("lme/dispatch/QualificationDetailSlideout") as QualificationDetailSlideout;
        SlideoutDecorator.decorateAndSlideIn(layout, {
            title: "Qualification Details",
            fillHeight: true,
            width: "850",
            overlayProps: { greyedBackground: true, closeOnClickOff: true },
            layoutLoadListeners: [
                async (event) => {
                    const batchResultList = await Api.post("lme/powerbroker/carrier-qualifications/batch", { "payee_id": payeeId });
                    const batchResults = batchResultList.data.map(batchResult => new ModelRow(layout.sourceCarrierQualifications.url, false, batchResult.result[0]));
                    layout.sourceCarrierQualifications.setRowsAndMode(DataSourceMode.NONE, batchResults);
                }
            ]
        });
    }

    tableDetailsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const relevantProps = modelRow.getBoolean("passed", false)
            ? modelRow.getBoolean("warning", false)
                ? { "name": ImageName.triangleWarning, "color": "warning" }
                : { "name": ImageName.circleCheck, "color": "success" }
            : { "name": ImageName.circleX, "color": "error" }
        const imageStatus = tableRow.findComponentById("imageStatus") as Image;
        if (imageStatus) {
            imageStatus.setProps(relevantProps);
        }
    }

    tableDetailsOnRowExpand(event: TableRowExpansionEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const details = modelRow.get("details", []);
        const expandPanel = event.expandComponentParent as Panel;
        const expand = expandPanel.findComponentById("panelScoringDetails") as Panel;
        for (const detail of details) {
            const descr = detail.descr || "";
            const points = detail.points || 0;
            const labelDetail = new Label({
                text: descr,
                fillRow: true,
                rowBreak: false,
                color: points > 0 ? "error" : "default",
            });
            if (points > 0) {
                labelDetail.tooltip = this.buildPointsTooltip(detail);
            }
            expand.add(labelDetail);
            expand.add(new Label({
                text: points.toString(),
                rowBreak: true,
                align: HorizontalAlignment.RIGHT,
                color: points > 0 ? "error" : "default",
                marginRight: 36
            }));
        }
    }

    buildPointsTooltip(detail): string {
        if (detail.type == "S") {
            return `Required Value: ${detail.expected}\nCarrier Value: ${detail.actual}`;
        } else if (detail.type == "D") {
            return `Required Value: ${detail.expected1} and ${detail.expected2}\nCarrier Value: ${detail.actual1} and ${detail.actual2}`;
        } else if (detail.type == "C") {
            return `Required Value: ${detail.expected1} or ${detail.expected2}\nCarrier Value: ${detail.actual1} and ${detail.actual2}`;
        }
    }
}
